import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";

@customElement("bp-slide-anchor")
export class SlideAnchor extends LitElement {
  static styles = css`
    a[data-empty="false"] {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: var(--line-height-normal);
      color: inherit;
      border: 1px solid currentColor;
      font-weight: var(--font-weight-semibold);
      border-radius: var(--radius-full);
      padding: var(--size-0-5) var(--size-1-5);
    }

    a[data-empty="true"] {
      display: none;
    }
  `;

  @property({ attribute: "slide-id" })
  slideId?: string;

  @property({ type: Boolean, attribute: "show" })
  show = false;

  @state()
  empty = true;

  scrollIntoView() {
    let previousElement;

    if (this.parentElement?.tagName && this.parentElement?.tagName === "P") {
      previousElement = this.parentElement.previousElementSibling;
    } else {
      previousElement = this.previousElementSibling;
    }

    const allowedSiblings = ["H1", "H2", "H3", "H4"];

    if (previousElement) {
      const scrollTarget = allowedSiblings.includes(previousElement.nodeName)
        ? previousElement
        : this.shadowRoot?.querySelector("a");

      scrollTarget?.scrollIntoView({ behavior: "smooth", inline: "nearest" });
    }
  }

  handleSlotchange({ target }: { target: HTMLSlotElement }) {
    this.empty = !this.show || !target.assignedNodes({ flatten: true }).length;
  }

  render() {
    return html`
      <a id="${ifDefined(this.slideId)}" data-empty="${this.empty}">
        <slot @slotchange=${this.handleSlotchange}></slot>
      </a>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-slide-anchor": SlideAnchor;
  }
}
